interface RateDetail {
    price: number
    prev_price: number
    today_price_max: number
    diff: number
    today_price_min: number
    direction_class?: string
}

interface RatesGroup {
    [key: string]: RateDetail
}

interface SpotRatesUpdatedPayload {
    exchange_rate: Record<string, number>
    last_data_points: Record<string, Record<string, [number, number]>>
    spot_rates: Record<string, RatesGroup | string>
    socket?: any
}

export default defineNuxtPlugin(async (nuxtApp) => {
    nuxtApp.$socket.on('spot_rates_updated', (newData: SpotRatesUpdatedPayload) => {
        const spotRatesStore = useSpotRatesStore()
        const localeStore = useLocaleStore()
        const currencyCode = localeStore.currency.code
        const exchangeRate = newData.exchange_rate[currencyCode]

        delete newData.socket
        spotRatesStore.datetime = newData.spot_rates.datetime;

        const ratio = spotRatesStore.ratio;

        if (ratio) {
            const [firstMetal, secondMetal] = ratio.split('-');
            const firstMetalData = newData.spot_rates[spotRatesStore.type][firstMetal].oz;
            const secondMetalData = newData.spot_rates[spotRatesStore.type][secondMetal].oz;

            const dateStr = newData.spot_rates.datetime;
            const isoStr = dateStr.replace(' ', 'T');
            const dt = new Date(isoStr);

            const datetimeMs = dt.getTime();

            spotRatesStore.addChartPoint('metals-ratio', 'oz', [datetimeMs, firstMetalData.price / secondMetalData.price]);
        } else {
            Object.keys(newData.spot_rates[spotRatesStore.type]).forEach((metal) => {
                if (metal === 'rhodium') return

                const ratesGroup = newData.spot_rates[spotRatesStore.type][metal] as RatesGroup

                if (!spotRatesStore.data[spotRatesStore.type][metal]) {
                    spotRatesStore.data[spotRatesStore.type][metal] = {}
                }

                if (typeof ratesGroup === 'object' && ratesGroup !== null) {
                    Object.keys(ratesGroup).forEach((unit) => {
                        ratesGroup[unit].prev_price /= exchangeRate
                        ratesGroup[unit].price /= exchangeRate
                        ratesGroup[unit].today_price_max /= exchangeRate
                        ratesGroup[unit].today_price_min /= exchangeRate
                        ratesGroup[unit].diff /= exchangeRate
                        ratesGroup[unit].direction_class = ratesGroup[unit].icon;
                    })
                }

                spotRatesStore.data[spotRatesStore.type][metal] = ratesGroup

                setTimeout(() => {
                    if (spotRatesStore.data[spotRatesStore.type][metal]['oz']) {
                        spotRatesStore.data[spotRatesStore.type][metal]['oz'].direction_class = 'none'
                    }
                }, 3000)
            })

            for (const metal of Object.keys(newData.last_data_points)) {
                if (metal === 'rhodium') continue

                const unitsMap = newData.last_data_points[metal]
                for (const unit of Object.keys(unitsMap)) {
                    const existing = spotRatesStore.chartRanges[metal]?.[unit]
                    if (Array.isArray(existing) && existing.length > 0) {
                        let point = unitsMap[unit]
                        point[1] /= exchangeRate;
                        spotRatesStore.addChartPoint(metal, unit, point)
                    }
                }
            }
        }

        Object.values(spotRatesStore.callbacks).forEach((fn) => fn({updating_rates: true}))
    })
})
